import { useDrag } from 'react-dnd';
import fieldData from '../Modals/fieldsData';
const style = {
  padding: '0.5rem 1rem',
  cursor: 'move',
  float: 'left',
};
export const DraggableComponent = function DraggableComponent({
  children,
  name,
  fieldId,
  Type,
  onFieldDrop,
}) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: Type,
    item: { name },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),

    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult) {
        const selectedField = fieldData.filter(
          (field) => field?.type === item?.name
        );
        onFieldDrop(selectedField[0]);
      }
    },
  }));

  const opacity = isDragging ? 0.4 : 1;
  return (
    <div ref={drag} style={{ ...style, opacity }} data-id={`${fieldId}`}>
      {children}
    </div>
  );
};
